export interface City {
  name: string;
  lat: number;
  lon: number;
}

export interface State {
  name: string;
  cities: City[];
}

export interface Country {
  name: string;
  timezone: string;
  states: State[];
}

export const locationData: Country[] = [
  {
    name: 'India',
    timezone: '+05:30',
    states: [
      {
        name: 'Delhi',
        cities: [
          { name: 'New Delhi', lat: 28.6139, lon: 77.2090 },
          { name: 'Delhi', lat: 28.7041, lon: 77.1025 },
          { name: 'Dwarka', lat: 28.5921, lon: 77.0460 },
          { name: 'Rohini', lat: 28.7495, lon: 77.0736 },
          { name: 'Janakpuri', lat: 28.6219, lon: 77.0819 }
        ]
      },
      {
        name: 'Maharashtra',
        cities: [
          { name: 'Mumbai', lat: 19.0760, lon: 72.8777 },
          { name: 'Pune', lat: 18.5204, lon: 73.8567 },
          { name: 'Nagpur', lat: 21.1458, lon: 79.0882 },
          { name: 'Thane', lat: 19.2183, lon: 72.9781 },
          { name: 'Nashik', lat: 19.9975, lon: 73.7898 },
          { name: 'Aurangabad', lat: 19.8762, lon: 75.3433 },
          { name: 'Solapur', lat: 17.6599, lon: 75.9064 }
        ]
      },
      {
        name: 'Karnataka',
        cities: [
          { name: 'Bangalore', lat: 12.9716, lon: 77.5946 },
          { name: 'Mysore', lat: 12.2958, lon: 76.6394 },
          { name: 'Hubli', lat: 15.3647, lon: 75.1240 },
          { name: 'Mangalore', lat: 12.9141, lon: 74.8560 },
          { name: 'Belgaum', lat: 15.8497, lon: 74.4977 },
          { name: 'Gulbarga', lat: 17.3297, lon: 76.8343 }
        ]
      },
      {
        name: 'West Bengal',
        cities: [
          { name: 'Kolkata', lat: 22.5726, lon: 88.3639 },
          { name: 'Howrah', lat: 22.5958, lon: 88.2636 },
          { name: 'Durgapur', lat: 23.5204, lon: 87.3119 },
          { name: 'Asansol', lat: 23.6739, lon: 86.9524 },
          { name: 'Siliguri', lat: 26.7271, lon: 88.3953 }
        ]
      },
      {
        name: 'Tamil Nadu',
        cities: [
          { name: 'Chennai', lat: 13.0827, lon: 80.2707 },
          { name: 'Coimbatore', lat: 11.0168, lon: 76.9558 },
          { name: 'Madurai', lat: 9.9252, lon: 78.1198 },
          { name: 'Tiruchirappalli', lat: 10.7905, lon: 78.7047 },
          { name: 'Salem', lat: 11.6643, lon: 78.1460 },
          { name: 'Tirunelveli', lat: 8.7139, lon: 77.7567 }
        ]
      },
      {
        name: 'Telangana',
        cities: [
          { name: 'Hyderabad', lat: 17.3850, lon: 78.4867 },
          { name: 'Warangal', lat: 17.9689, lon: 79.5941 },
          { name: 'Nizamabad', lat: 18.6725, lon: 78.0942 },
          { name: 'Khammam', lat: 17.2473, lon: 80.1514 }
        ]
      },
      {
        name: 'Gujarat',
        cities: [
          { name: 'Ahmedabad', lat: 23.0225, lon: 72.5714 },
          { name: 'Surat', lat: 21.1702, lon: 72.8311 },
          { name: 'Vadodara', lat: 22.3072, lon: 73.1812 },
          { name: 'Rajkot', lat: 22.3039, lon: 70.8022 },
          { name: 'Bhavnagar', lat: 21.7645, lon: 72.1519 },
          { name: 'Jamnagar', lat: 22.4707, lon: 70.0577 }
        ]
      },
      {
        name: 'Rajasthan',
        cities: [
          { name: 'Jaipur', lat: 26.9124, lon: 75.7873 },
          { name: 'Jodhpur', lat: 26.2389, lon: 73.0243 },
          { name: 'Udaipur', lat: 24.5854, lon: 73.7125 },
          { name: 'Kota', lat: 25.2138, lon: 75.8648 },
          { name: 'Bikaner', lat: 28.0229, lon: 73.3119 },
          { name: 'Ajmer', lat: 26.4499, lon: 74.6399 }
        ]
      },
      {
        name: 'Uttar Pradesh',
        cities: [
          { name: 'Lucknow', lat: 26.8467, lon: 80.9462 },
          { name: 'Kanpur', lat: 26.4499, lon: 80.3319 },
          { name: 'Ghaziabad', lat: 28.6692, lon: 77.4538 },
          { name: 'Agra', lat: 27.1767, lon: 78.0081 },
          { name: 'Varanasi', lat: 25.3176, lon: 82.9739 },
          { name: 'Meerut', lat: 28.9845, lon: 77.7064 },
          { name: 'Allahabad', lat: 25.4358, lon: 81.8463 },
          { name: 'Bareilly', lat: 28.3670, lon: 79.4304 }
        ]
      },
      {
        name: 'Madhya Pradesh',
        cities: [
          { name: 'Indore', lat: 22.7196, lon: 75.8577 },
          { name: 'Bhopal', lat: 23.2599, lon: 77.4126 },
          { name: 'Jabalpur', lat: 23.1815, lon: 79.9864 },
          { name: 'Gwalior', lat: 26.2183, lon: 78.1828 },
          { name: 'Ujjain', lat: 23.1765, lon: 75.7885 }
        ]
      },
      {
        name: 'Punjab',
        cities: [
          { name: 'Ludhiana', lat: 30.9010, lon: 75.8573 },
          { name: 'Amritsar', lat: 31.6340, lon: 74.8723 },
          { name: 'Jalandhar', lat: 31.3260, lon: 75.5762 },
          { name: 'Patiala', lat: 30.3398, lon: 76.3869 },
          { name: 'Bathinda', lat: 30.2110, lon: 74.9455 }
        ]
      },
      {
        name: 'Haryana',
        cities: [
          { name: 'Faridabad', lat: 28.4089, lon: 77.3178 },
          { name: 'Gurgaon', lat: 28.4595, lon: 77.0266 },
          { name: 'Panipat', lat: 29.3909, lon: 76.9635 },
          { name: 'Ambala', lat: 30.3782, lon: 76.7767 },
          { name: 'Yamunanagar', lat: 30.1290, lon: 77.2674 }
        ]
      },
      {
        name: 'Bihar',
        cities: [
          { name: 'Patna', lat: 25.5941, lon: 85.1376 },
          { name: 'Gaya', lat: 24.7955, lon: 84.9994 },
          { name: 'Bhagalpur', lat: 25.2425, lon: 86.9842 },
          { name: 'Muzaffarpur', lat: 26.1209, lon: 85.3647 },
          { name: 'Darbhanga', lat: 26.1542, lon: 85.8918 }
        ]
      },
      {
        name: 'Kerala',
        cities: [
          { name: 'Thiruvananthapuram', lat: 8.5241, lon: 76.9366 },
          { name: 'Kochi', lat: 9.9312, lon: 76.2673 },
          { name: 'Kozhikode', lat: 11.2588, lon: 75.7804 },
          { name: 'Kollam', lat: 8.8932, lon: 76.6141 },
          { name: 'Thrissur', lat: 10.5276, lon: 76.2144 }
        ]
      },
      {
        name: 'Andhra Pradesh',
        cities: [
          { name: 'Visakhapatnam', lat: 17.6868, lon: 83.2185 },
          { name: 'Vijayawada', lat: 16.5062, lon: 80.6480 },
          { name: 'Guntur', lat: 16.3067, lon: 80.4365 },
          { name: 'Nellore', lat: 14.4426, lon: 79.9865 },
          { name: 'Kurnool', lat: 15.8281, lon: 78.0373 }
        ]
      },
      {
        name: 'Odisha',
        cities: [
          { name: 'Bhubaneswar', lat: 20.2961, lon: 85.8245 },
          { name: 'Cuttack', lat: 20.4625, lon: 85.8828 },
          { name: 'Rourkela', lat: 22.2604, lon: 84.8536 },
          { name: 'Brahmapur', lat: 19.3150, lon: 84.7941 }
        ]
      },
      {
        name: 'Jharkhand',
        cities: [
          { name: 'Ranchi', lat: 23.3441, lon: 85.3096 },
          { name: 'Jamshedpur', lat: 22.8046, lon: 86.2029 },
          { name: 'Dhanbad', lat: 23.7957, lon: 86.4304 },
          { name: 'Bokaro', lat: 23.6693, lon: 86.1511 }
        ]
      },
      {
        name: 'Assam',
        cities: [
          { name: 'Guwahati', lat: 26.1445, lon: 91.7362 },
          { name: 'Silchar', lat: 24.8333, lon: 92.7789 },
          { name: 'Dibrugarh', lat: 27.4728, lon: 94.9120 },
          { name: 'Jorhat', lat: 26.7509, lon: 94.2037 }
        ]
      },
      {
        name: 'Chhattisgarh',
        cities: [
          { name: 'Raipur', lat: 21.2514, lon: 81.6296 },
          { name: 'Bhilai', lat: 21.2095, lon: 81.3807 },
          { name: 'Bilaspur', lat: 22.0797, lon: 82.1409 },
          { name: 'Korba', lat: 22.3595, lon: 82.7501 }
        ]
      },
      {
        name: 'Uttarakhand',
        cities: [
          { name: 'Dehradun', lat: 30.3165, lon: 78.0322 },
          { name: 'Haridwar', lat: 29.9457, lon: 78.1642 },
          { name: 'Roorkee', lat: 29.8543, lon: 77.8880 },
          { name: 'Haldwani', lat: 29.2183, lon: 79.5130 }
        ]
      },
      {
        name: 'Goa',
        cities: [
          { name: 'Panaji', lat: 15.4909, lon: 73.8278 },
          { name: 'Margao', lat: 15.2832, lon: 73.9667 },
          { name: 'Vasco da Gama', lat: 15.3989, lon: 73.8151 },
          { name: 'Mapusa', lat: 15.5909, lon: 73.8090 }
        ]
      },
      {
        name: 'Himachal Pradesh',
        cities: [
          { name: 'Shimla', lat: 31.1048, lon: 77.1734 },
          { name: 'Dharamshala', lat: 32.2190, lon: 76.3234 },
          { name: 'Solan', lat: 30.9045, lon: 77.0967 },
          { name: 'Mandi', lat: 31.7084, lon: 76.9319 }
        ]
      },
      {
        name: 'Jammu and Kashmir',
        cities: [
          { name: 'Srinagar', lat: 34.0837, lon: 74.7973 },
          { name: 'Jammu', lat: 32.7266, lon: 74.8570 },
          { name: 'Anantnag', lat: 33.7311, lon: 75.1481 },
          { name: 'Baramulla', lat: 34.2095, lon: 74.3434 }
        ]
      },
      {
        name: 'Chandigarh',
        cities: [
          { name: 'Chandigarh', lat: 30.7333, lon: 76.7794 }
        ]
      },
      {
        name: 'Puducherry',
        cities: [
          { name: 'Puducherry', lat: 11.9416, lon: 79.8083 }
        ]
      }
    ]
  },
  {
    name: 'United States',
    timezone: '-05:00',
    states: [
      {
        name: 'California',
        cities: [
          { name: 'Los Angeles', lat: 34.0522, lon: -118.2437 },
          { name: 'San Francisco', lat: 37.7749, lon: -122.4194 },
          { name: 'San Diego', lat: 32.7157, lon: -117.1611 },
          { name: 'San Jose', lat: 37.3382, lon: -121.8863 },
          { name: 'Sacramento', lat: 38.5816, lon: -121.4944 }
        ]
      },
      {
        name: 'New York',
        cities: [
          { name: 'New York City', lat: 40.7128, lon: -74.0060 },
          { name: 'Buffalo', lat: 42.8864, lon: -78.8784 },
          { name: 'Rochester', lat: 43.1566, lon: -77.6088 },
          { name: 'Albany', lat: 42.6526, lon: -73.7562 }
        ]
      },
      {
        name: 'Texas',
        cities: [
          { name: 'Houston', lat: 29.7604, lon: -95.3698 },
          { name: 'Dallas', lat: 32.7767, lon: -96.7970 },
          { name: 'Austin', lat: 30.2672, lon: -97.7431 },
          { name: 'San Antonio', lat: 29.4241, lon: -98.4936 }
        ]
      },
      {
        name: 'Florida',
        cities: [
          { name: 'Miami', lat: 25.7617, lon: -80.1918 },
          { name: 'Orlando', lat: 28.5383, lon: -81.3792 },
          { name: 'Tampa', lat: 27.9506, lon: -82.4572 },
          { name: 'Jacksonville', lat: 30.3322, lon: -81.6557 }
        ]
      },
      {
        name: 'Illinois',
        cities: [
          { name: 'Chicago', lat: 41.8781, lon: -87.6298 },
          { name: 'Aurora', lat: 41.7606, lon: -88.3201 },
          { name: 'Naperville', lat: 41.7508, lon: -88.1535 }
        ]
      }
    ]
  },
  {
    name: 'United Kingdom',
    timezone: '+00:00',
    states: [
      {
        name: 'England',
        cities: [
          { name: 'London', lat: 51.5074, lon: -0.1278 },
          { name: 'Manchester', lat: 53.4808, lon: -2.2426 },
          { name: 'Birmingham', lat: 52.4862, lon: -1.8904 },
          { name: 'Leeds', lat: 53.8008, lon: -1.5491 },
          { name: 'Liverpool', lat: 53.4084, lon: -2.9916 }
        ]
      },
      {
        name: 'Scotland',
        cities: [
          { name: 'Edinburgh', lat: 55.9533, lon: -3.1883 },
          { name: 'Glasgow', lat: 55.8642, lon: -4.2518 },
          { name: 'Aberdeen', lat: 57.1497, lon: -2.0943 }
        ]
      }
    ]
  },
  {
    name: 'Canada',
    timezone: '-05:00',
    states: [
      {
        name: 'Ontario',
        cities: [
          { name: 'Toronto', lat: 43.6532, lon: -79.3832 },
          { name: 'Ottawa', lat: 45.4215, lon: -75.6972 },
          { name: 'Mississauga', lat: 43.5890, lon: -79.6441 }
        ]
      },
      {
        name: 'British Columbia',
        cities: [
          { name: 'Vancouver', lat: 49.2827, lon: -123.1207 },
          { name: 'Victoria', lat: 48.4284, lon: -123.3656 }
        ]
      },
      {
        name: 'Quebec',
        cities: [
          { name: 'Montreal', lat: 45.5017, lon: -73.5673 },
          { name: 'Quebec City', lat: 46.8139, lon: -71.2080 }
        ]
      }
    ]
  },
  {
    name: 'Australia',
    timezone: '+10:00',
    states: [
      {
        name: 'New South Wales',
        cities: [
          { name: 'Sydney', lat: -33.8688, lon: 151.2093 },
          { name: 'Newcastle', lat: -32.9283, lon: 151.7817 }
        ]
      },
      {
        name: 'Victoria',
        cities: [
          { name: 'Melbourne', lat: -37.8136, lon: 144.9631 },
          { name: 'Geelong', lat: -38.1499, lon: 144.3617 }
        ]
      },
      {
        name: 'Queensland',
        cities: [
          { name: 'Brisbane', lat: -27.4698, lon: 153.0251 },
          { name: 'Gold Coast', lat: -28.0167, lon: 153.4000 }
        ]
      }
    ]
  },
  {
    name: 'UAE',
    timezone: '+04:00',
    states: [
      {
        name: 'Dubai',
        cities: [
          { name: 'Dubai', lat: 25.2048, lon: 55.2708 }
        ]
      },
      {
        name: 'Abu Dhabi',
        cities: [
          { name: 'Abu Dhabi', lat: 24.4539, lon: 54.3773 }
        ]
      },
      {
        name: 'Sharjah',
        cities: [
          { name: 'Sharjah', lat: 25.3463, lon: 55.4209 }
        ]
      }
    ]
  },
  {
    name: 'Singapore',
    timezone: '+08:00',
    states: [
      {
        name: 'Singapore',
        cities: [
          { name: 'Singapore', lat: 1.3521, lon: 103.8198 }
        ]
      }
    ]
  }
];
